export default "__VITE_ASSET__DtQsaQQE__"